import React from "react";
import "../css/SuccessfulPage.css";
import dogCatImage from "../assets/view-cats-dogs-showing-friendship 1.png";
import checkmarkImage from "../assets/success-img.png";
import { Link } from "react-router-dom";
const SuccessfulPage = () => {
  return (
    <div className="sp-login-container">
      <div className="sp-login-left">
        <h2 className="sp-login-left-header">
          Reset Your Password – Reconnect With Your Pet’s World!
        </h2>
        <img className="sp-image" src={dogCatImage} alt="Dog and Cat" />
      </div>
      <div className="sp-login-right-success">
        <div className="success-icon">
          <img src={checkmarkImage} alt="Success" />
        </div>
        <h2 className="sp-login-right-header">Successful</h2>
        <p className="sp-instruction">
          Congratulations! Your password has been changed. Click continue to
          login
        </p>

        <Link to="/Dashboard" className="sp-confirm-button">
          Continue
        </Link>
      </div>
    </div>
  );
};

export default SuccessfulPage;